import Slider from 'rc-slider';
import React, { useContext, useEffect, useRef } from 'react';
import opacitySliderContext from '../../context/opacitySliderContext';
import './OpacitySlider.css';
import 'rc-slider/assets/index.css';

export interface Opacity {
    visible: boolean;
    value: number;
    x: number;
    y: number;
}

export const OpacitySlider = () => {
    const {opacity, setOpacity}= useContext(opacitySliderContext);
    const sliderRef = useRef<any>(null);
    
    useEffect(() => {
        // Focus the slider when component mounts
        if (sliderRef.current) {
            sliderRef.current.focus();
        }
    }, []);

    
    let position= {};
    if (opacity?.x){
        position= { ...position, top: opacity.x};
    }
    if (opacity?.y){
        position= {...position, left: (opacity.y + 10 )};
  
    }
    
    
    return (
        
        <div className={ 'slider-control' } style={ position }
             >
            <Slider
                ref={sliderRef}
                onChange={ (nextValues) => {
                    setOpacity((prev: any) => ({ ...prev, value: nextValues }));
                } }
                styles={ {
                    track: {
                        background: 'rgb(28, 83, 236)',
                    },
                } }
                min={ 0 }
                max={ 100 }
                defaultValue={ opacity.value }
                step={ 1 }
                tabIndex={0}
                aria-label="Opacity control"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={opacity.value}
                aria-valuetext={`${opacity.value}% opacity`}
            />
        </div>
    );
}
